import React from 'react';
import { Video } from 'lucide-react';
import Button from './Button';

export interface PreRecordingFormData {
  phobiaType?: string;
  exposureLevel?: number;
  triggers?: string[];
  sessionGoals?: string;
}

interface PreRecordingFormProps {
  onStartRecording: (data: PreRecordingFormData) => void;
  onCancel: () => void;
  ticketInfo?: {
    title: string;
    description?: string;
    requestedBy: string;
  };
}

const PreRecordingForm: React.FC<PreRecordingFormProps> = ({
  onStartRecording,
  onCancel,
  ticketInfo,
}) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8 text-center">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">New ETR Video</h1>
        <p className="mt-2 text-sm sm:text-base text-gray-600">
          Start a standalone recording session. For booked rooms, use <strong>My Tickets</strong> instead.
        </p>
        {ticketInfo && (
          <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4 text-left">
            <h3 className="font-semibold text-blue-900 mb-2">Recording request</h3>
            <p className="text-sm text-blue-800">
              <strong>Title:</strong> {ticketInfo.title}
            </p>
            {ticketInfo.description && (
              <p className="text-sm text-blue-800 mt-1">
                <strong>Description:</strong> {ticketInfo.description}
              </p>
            )}
            <p className="text-sm text-blue-800 mt-1">
              <strong>Requested by:</strong> {ticketInfo.requestedBy}
            </p>
          </div>
        )}
      </div>

      <div className="etr-surface p-8 text-center space-y-6">
        <Video className="h-12 w-12 text-primary-600 mx-auto" />
        <p className="text-gray-600">
          You will record your screen in the next step. Session details can be edited after recording.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Button
            variant="primary"
            leftIcon={<Video className="h-4 w-4" />}
            onClick={() => onStartRecording({})}
          >
            Start recording
          </Button>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PreRecordingForm;
